import { ReactNode } from "react";

type Props<T> =
  | {
      label: string;
      pub: T | undefined;
      confidential: T | undefined | null;
      render: (value: T) => ReactNode;
    }
  | {
      label: string;
      pub: ReactNode | undefined;
      confidential: ReactNode | undefined | null;
    };

// Handles the logic needed for displaying or hiding rows. If render is not set
// the values pub and confidential are placed directly in the dom, otherwise
// render is called first. If confidential===null it is considered to exist but
// not known/hidden.
export function DoubleRowDisplay<T>(props: Props<T>) {
  const { label } = props;
  let confidential: ReactNode;
  let pub: ReactNode;

  // Logic for making render prop optional
  if ("render" in props) {
    confidential = props.confidential && props.render(props.confidential);
    pub = props.pub && props.render(props.pub);
  } else {
    confidential = props.confidential;
    pub = props.pub;
  }

  return (
    <>
      {confidential && (
        <tr>
          <td>
            {label} <span className="gray">(confidential)</span>
          </td>
          <td>{confidential}</td>
        </tr>
      )}
      {confidential === null && (
        <tr>
          <td>
            {label} <span className="gray">(confidential)</span>
          </td>
          <td className="gray">[HIDDEN]</td>
        </tr>
      )}
      {pub !== undefined && (
        <tr>
          <td>{label}</td>
          <td>{pub}</td>
        </tr>
      )}
    </>
  );
}
